"use strict";

require("./CompanyUserRoleService.js");
require("../users/CompanyUserService.js");
// require("./CompanyEditTextBoxCtrl.js");

CompanyUserRoleEditCtrl.$inject = [
  "$scope",
  "$rootScope",
  "$state",
  "$q",
  "$filter",
  "$modal",
  "$window",
  "$stateParams",
  "$translate",
  "CompanyUserRoleService",
  "CompanyUserService",
  "CompanyPublicationService",
  "CompanyMessageService",
  "CompanyCommentsService",
  "CompanyTaskService",
  "role",
  "members",
  "config",
  "UploadTracker",
  "uiSortableMultiSelectionMethods",
  "growl",
  "userRoles",
];

function CompanyUserRoleEditCtrl(
  $scope,
  $rootScope,
  $state,
  $q,
  $filter,
  $modal,
  $window,
  $stateParams,
  $translate,
  CompanyUserRoleService,
  CompanyUserService,
  CompanyPublicationService,
  CompanyMessageService,
  CompanyCommentsService,
  CompanyTaskService,
  role,
  members,
  config,
  uploadTracker,
  uiSortableMultiSelectionMethods,
  growl,
  userRoles
) {
  $scope.role = role;
  $scope.companyId = $stateParams.companyId;
  $scope.search = "";

  function getNestedChildren(menu, parent) {
    var arr = menu;
    var out = [];
    for (var i in arr) {
      if (arr[i].parentId === parent) {
        var children = getNestedChildren(arr, arr[i].id);
        if (children.length) {
          arr[i].children = children;
        }
        out.push(arr[i]);
      }
    }
    return sortMenu(out);
  }

  function sortMenu(menu) {
    menu.sort(function(a, b) {
      if (a.order === b.order) {
        return 0;
      } else if (a.order === 0) {
        return 1;
      } else if (b.order === 0) {
        return -1;
      }
      return a.order < b.order ? -1 : 1;
    });

    menu.forEach(function(v, i) {
      if (v.children && v.children.length > 1) {
        v.children.sort(function(a, b) {
          if (a.order === b.order) {
            return 0;
          } else if (a.order === 0) {
            return 1;
          } else if (b.order === 0) {
            return -1;
          }
          return a.order < b.order ? -1 : 1;
        });
      }
    });

    return menu;
  }

  $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
  $scope.$on(
    "menuChange",
    function(e, data) {
      delete data.children;
      var index = $scope.role.menus.findIndex(function(m) {
        return data.id === m.id;
      });
      if (index > -1) {
        var oldMenu = JSON.parse(JSON.stringify($scope.role.menus[index]));
        $scope.role.menus[index] = data;
        if (oldMenu.parentId !== data.parentId) {
          $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
        }
      }
    },
    true
  );

  $scope.addMenu = function() {
    $scope.role.menus.push({
      id:
        $scope.role.menus.length > 0
          ? Math.max.apply(
              Math,
              $scope.role.menus.map(function(o) {
                return o.id + 1;
              })
            )
          : 1,
      text: "",
      link: "#",
      parentId: null,
      order: 0,
    });
    $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
  };

  $scope.toggleMenu = function(menu) {
    // var $parent = jQuery("#" + id).parent();
    // if ($parent.hasClass("show-child")) {
    //   $parent.removeClass("show-child");
    //   $parent.find(".user-role__main-toggle > i").removeClass("fa-compress");
    //   $parent.find(".user-role__main-toggle > i").addClass("fa-expand");
    // } else {
    //   $parent.find(".user-role__main-toggle > i").removeClass("fa-expand");
    //   $parent.find(".user-role__main-toggle > i").addClass("fa-compress");
    //   $parent.addClass("show-child");
    // }
    $scope.role.menus = $scope.role.menus.map(function(v, i) {
      if (v.id === menu.id) {
        v.show = !v.show;
      }
      return v;
    });
     $scope.nestedMenu = getNestedChildren($scope.role.menus, null);

  };

  $scope.remove = function(item) {
    $scope.role.menus = $scope.role.menus.filter(function(v, i) {
      return v.id !== item.id;
    });
    $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
  };

  $scope.$on("removeMenuItem", function(event, item) {
    $scope.remove(item);
  });

  $rootScope.$emit("currentUserRole", $scope.role.id);
  if ($scope.role.template !== null && !$scope.role.template.data) {
    $scope.role.template.data = [];
  }

  $scope.userRoles = userRoles.filter(function(item) {
    return (
      item.id !== role.id &&
      (item.template.id === "1" ||
        item.template.id === "2" ||
        item.template.id === "5" ||
        item.template.id === "6")
    );
  });

  // function getBlogLastest(data) {
  //   if (
  //     data.columnType === "BLOG" &&
  //     (data.columnData.object || data.columnData.blogId)
  //   ) {
  //     CompanyPublicationService.getPostLastest(
  //       {
  //         companyId: $stateParams.companyId,
  //         publicationId: data.columnData.object
  //           ? data.columnData.object.id
  //           : data.columnData.blogId,
  //         only: data.columnData.only,
  //         limit: data.columnData.showThreePosts ? 3 : 1,
  //       },
  //       function(resp) {
  //         $scope.role.template.data[
  //           $scope.role.template.data.indexOf(data)
  //         ].blogLastest = resp;
  //       }
  //     );
  //   }
  // }
  // setTimeout(function() {
  //   var options = {
  //     alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //       navigator.userAgent
  //     ),
  //     disableOneColumnMode: true,
  //   };
  //   jQuery(".grid-stack").gridstack(options);
  //   jQuery(".grid-stack").on("dragstop", function() {
  //     setTimeout(function() {
  //       jQuery(".grid-stack-item.ui-draggable").each(function() {
  //         var item = jQuery(this);
  //         var index = item.attr("index");
  //         $scope.role.template.data[index].chartData.gsX = item.attr(
  //           "data-gs-x"
  //         );
  //         $scope.role.template.data[index].chartData.gsY = item.attr(
  //           "data-gs-y"
  //         );
  //         $scope.role.template.data[index].chartData.gsWidth = item.attr(
  //           "data-gs-width"
  //         );
  //         $scope.role.template.data[index].chartData.gsHeigth = item.attr(
  //           "data-gs-height"
  //         );
  //       });
  //     }, 1000);
  //   });
  //   jQuery(".grid-stack").on("resizestop", function() {
  //     setTimeout(function() {
  //       jQuery(".grid-stack-item.ui-draggable").each(function() {
  //         var item = jQuery(this);
  //         var index = item.attr("index");
  //         $scope.role.template.data[index].chartData.gsX = item.attr(
  //           "data-gs-x"
  //         );
  //         $scope.role.template.data[index].chartData.gsY = item.attr(
  //           "data-gs-y"
  //         );
  //         $scope.role.template.data[index].chartData.gsWidth = item.attr(
  //           "data-gs-width"
  //         );
  //         $scope.role.template.data[index].chartData.gsHeigth = item.attr(
  //           "data-gs-height"
  //         );
  //       });
  //     }, 1000);
  //   });
  // }, 10);

  // angular.element($window).on("resize", function() {
  //   var widthWindowH = angular.element($window).width();
  //   var grid = jQuery(".grid-stack").data("gridstack");
  //   if (widthWindowH < 1016 && widthWindowH > 825) {
  //     angular.forEach($scope.role.template.data, function(value, key) {
  //       grid.update(
  //         jQuery(".grid-stack-item:nth-child(" + (key + 1) + ")"),
  //         value.chartData.gsX === "0" ? 0 : 6,
  //         value.chartData.gsY,
  //         6,
  //         value.chartData.gsHeigth
  //       );
  //     });
  //   } else {
  //     if (widthWindowH >= 1016) {
  //       angular.forEach($scope.role.template.data, function(value, key) {
  //         grid.update(
  //           jQuery(".grid-stack-item:nth-child(" + (key + 1) + ")"),
  //           parseInt(value.chartData.gsX),
  //           parseInt(value.chartData.gsY),
  //           parseInt(value.chartData.gsWidth),
  //           parseInt(value.chartData.gsHeigth)
  //         );
  //       });
  //     } else {
  //       angular.forEach($scope.role.template.data, function(value, key) {
  //         grid.update(
  //           jQuery(".grid-stack-item:nth-child(" + (key + 1) + ")"),
  //           0,
  //           parseInt(value.chartData.gsY),
  //           12,
  //           parseInt(value.chartData.gsHeigth)
  //         );
  //       });
  //     }
  //   }
  // });

  // $scope.chartTypeList = [
  //   {
  //     value: "doughnut",
  //     name: "Chart Doughnut",
  //   },
  //   {
  //     value: "pie",
  //     name: "Chart Pie",
  //   },
  //   {
  //     value: "bar",
  //     name: "Chart Bar",
  //   },
  //   {
  //     value: "line-bar",
  //     name: "Chart Line & Bar",
  //   },
  //   {
  //     value: "line",
  //     name: "Chart Line",
  //   },
  //   {
  //     value: "horizontal-bar",
  //     name: "Chart H Bar",
  //   },
  // ];

  // if ($scope.role.template !== null) {
  //   var templateData = [];
  //   var yMax = 0;
  //   var heigthMax = 4;
  //   angular.forEach(role.template.data, function(value, key) {
  //     if ($scope.userRoles.length > 0) {
  //       var userRoleParams = $scope.userRoles.filter(function(item) {
  //         return item.id === value.reference.userRoleID;
  //       })[0];
  //       value.userRoleCurrent = userRoleParams
  //         ? userRoleParams
  //         : $scope.userRoles[0];
  //       value.reference.userRoleID = value.userRoleCurrent.id;
  //       value.referenceCentralInformation = value.userRoleCurrent.template.data
  //         ? value.userRoleCurrent.template.data.filter(function(item) {
  //             return item.centralInformation === false;
  //           })
  //         : [];
  //       var textBoxParams = value.referenceCentralInformation.filter(function(
  //         item
  //       ) {
  //         return item.id === value.reference.boxID;
  //       })[0];
  //       value.reference.boxID = textBoxParams
  //         ? textBoxParams.id
  //         : value.referenceCentralInformation.length > 0
  //         ? value.referenceCentralInformation[0].id
  //         : value.reference.boxID;
  //       value.currentIndex = textBoxParams
  //         ? value.userRoleCurrent.template.data.indexOf(textBoxParams) + 1
  //         : value.referenceCentralInformation.length > 0
  //         ? value.userRoleCurrent.template.data.indexOf(
  //             value.referenceCentralInformation[0]
  //           ) + 1
  //         : 0;
  //     }
  //     value.chartData = value.chartData ? value.chartData : {};
  //     value.chartData.gsX = angular.isDefined(value.chartData.gsX)
  //       ? value.chartData.gsX
  //       : key % 3 === 0
  //       ? 0
  //       : key % 3 === 1
  //       ? 4
  //       : 8;
  //     value.chartData.gsY = angular.isDefined(value.chartData.gsY)
  //       ? value.chartData.gsY
  //       : 0;
  //     value.chartData.gsWidth = angular.isDefined(value.chartData.gsWidth)
  //       ? value.chartData.gsWidth
  //       : 4;
  //     value.chartData.gsHeigth = angular.isDefined(value.chartData.gsHeigth)
  //       ? value.chartData.gsHeigth
  //       : 7;
  //     if (!value.isChart && value.columnType === "BLOG") {
  //       getBlogLastest(value);
  //     }
  //     templateData.push(value);
  //     if (parseInt(value.chartData.gsY) > yMax) {
  //       yMax = parseInt(value.chartData.gsY);
  //       heigthMax = parseInt(value.chartData.gsHeigth);
  //     }
  //   });
  //   $scope.role.template.data = templateData;

  //   angular.element($window).on("scroll", function() {
  //     if (angular.element($window).scrollTop() >= 80) {
  //       angular
  //         .element(".templates__dashboard-settings")
  //         .addClass("setting-scroll");
  //     } else {
  //       angular
  //         .element(".templates__dashboard-settings")
  //         .removeClass("setting-scroll");
  //     }
  //   });

    function checkPermissionGroup(group) {
      if (!group) {
        group = [];
      }
      if (group.length === 0) {
        return true;
      }

      var matched = false;
      angular.forEach(group, function(val) {
        if (!matched) {
          matched = $scope.customerPortals.some(function(g) {
            return g.id === val.id;
          });
        }
      });
      return matched;
    }

    if ($scope.role && $scope.role.template !== null) {
      angular.forEach($scope.role.links, function(v) {
        v.show = true;
        if (v.link.indexOf(config.appBase) !== -1) {
          if (!angular.isArray(v.groups)) {
            v.group = [];
          }
          var fullUserUrlRegex = /companies\/(.*)/i;
          if (
            !fullUserUrlRegex.test(v.link) ||
            !checkPermissionGroup(v.groups)
          ) {
            v.show = false;
          }
        }
      });
    }

    if ($scope.role.template !== null) {
      $scope.userLinks = angular.isDefined($scope.userInfo.features.userLinks)
        ? $scope.userInfo.features.userLinks
        : [];
    }

    // function removeBulkColumn(data) {
    //   $scope.role.template.data.splice(
    //     $scope.role.template.data.indexOf(data),
    //     1
    //   );
    //   $scope.save();
    // }

    // var angularModal;
    // $scope.showModalDeleteTextBox = function(data) {
    //   angularModal = $modal({
    //     scope: $scope,
    //     prefixEvent: "modalTextBox",
    //     controller: [
    //       "$scope",
    //       function($scope) {
    //         $scope.confirmName = $translate.instant("user-role.confirm-delete");
    //         $scope.activeDelete = function() {
    //           removeBulkColumn(data);
    //         };
    //       },
    //     ],
    //     templateUrl:
    //       "partials/company/publications/detail/latest/confirm-delete.html",
    //     show: true,
    //   });
    // };

    // $scope.$on("modalTextBox.hide", function() {
    //   angularModal.destroy();
    //   angularModal = null;
    // });

    var lastTemplateData = angular.copy(role);
    // $scope.posts = [];
    // $scope.comments = [];
    // $scope.latestTasks = [];

    // if (
    //   $scope.role.template &&
    //   ($scope.role.template.id === "1" ||
    //     $scope.role.template.id === "2" ||
    //     $scope.role.template.id === "5" ||
    //     $scope.role.template.id === "6")
    // ) {
    //   var boxMessage = $scope.role.template.data.filter(function(d) {
    //     return d.columnType === "MESSAGE";
    //   });
    //   if ($scope.info.features.blogs && $scope.role.showMessage) {
    //     CompanyMessageService.query(
    //       {
    //         companyId: $stateParams.companyId,
    //         limit: 4,
    //         showInList: false,
    //       },
    //       function(resp) {
    //         $scope.posts = resp;
    //         if (!boxMessage[0]) {
    //           if ($scope.posts.length > 0) {
    //             $scope.role.template.data.push({
    //               isChart: false,
    //               centralInformation: false,
    //               columnType: "MESSAGE",
    //               isFullBox: false,
    //               chartData: {
    //                 gsX: 0,
    //                 gsY: yMax + heigthMax,
    //                 gsWidth: 4,
    //                 gsHeigth: 4,
    //               },
    //             });
    //           }
    //         } else {
    //           if ($scope.posts.length === 0) {
    //             $scope.role.template.data.splice(
    //               $scope.role.template.data.indexOf(boxMessage[0]),
    //               1
    //             );
    //           }
    //         }
    //       },
    //       function() {
    //         if (boxMessage[0]) {
    //           $scope.role.template.data.splice(
    //             $scope.role.template.data.indexOf(boxMessage[0]),
    //             1
    //           );
    //         }
    //       }
    //     );
    //   } else {
    //     if (boxMessage[0]) {
    //       $scope.role.template.data.splice(
    //         $scope.role.template.data.indexOf(boxMessage[0]),
    //         1
    //       );
    //     }
    //   }

    //   var boxComment = $scope.role.template.data.filter(function(d) {
    //     return d.columnType === "COMMENT";
    //   });
    //   if ($scope.role.showComment) {
    //     CompanyCommentsService.queryComments(
    //       {
    //         companyId: $stateParams.companyId,
    //         limit: 4,
    //       },
    //       function(resp) {
    //         $scope.comments = resp;
    //         if (!boxComment[0]) {
    //           if ($scope.comments.length > 0) {
    //             $scope.role.template.data.push({
    //               isChart: false,
    //               centralInformation: false,
    //               columnType: "COMMENT",
    //               isFullBox: false,
    //               chartData: {
    //                 gsX: 0,
    //                 gsY: yMax + heigthMax,
    //                 gsWidth: 4,
    //                 gsHeigth: 4,
    //               },
    //             });
    //           }
    //         } else {
    //           if ($scope.comments.length === 0) {
    //             $scope.role.template.data.splice(
    //               $scope.role.template.data.indexOf(boxComment[0]),
    //               1
    //             );
    //           }
    //         }
    //       },
    //       function() {
    //         if (boxComment[0]) {
    //           $scope.role.template.data.splice(
    //             $scope.role.template.data.indexOf(boxComment[0]),
    //             1
    //           );
    //         }
    //       }
    //     );

    //     $scope.$on("notification", function(e, data) {
    //       if (data.type === "COMMENT") {
    //         var c = {
    //           id: data.message.id,
    //           text: data.message.text,
    //           createdAt: new Date().toISOString(),
    //           createdBy: data.sourceUser,
    //           objectRelative: data.publication,
    //         };
    //         $scope.$apply(function() {
    //           if (data.message.parentID === "undefined") {
    //             if ($scope.comments.length === 4) {
    //               $scope.comments.splice($scope.comments.length - 1, 1);
    //             }
    //             $scope.comments.unshift(c);
    //           } else {
    //             angular.forEach($scope.comments, function(item) {
    //               if (item.id === data.message.parentID) {
    //                 if (!item.commentChild) {
    //                   item.commentChild = [];
    //                 }
    //                 item.commentChild.push(c);
    //               }
    //             });
    //           }
    //         });
    //       }
    //     });
    //   } else {
    //     if (boxComment[0]) {
    //       $scope.role.template.data.splice(
    //         $scope.role.template.data.indexOf(boxComment[0]),
    //         1
    //       );
    //     }
    //   }
    //   var boxReminder = $scope.role.template.data.filter(function(d) {
    //     return d.columnType === "REMINDER";
    //   });
    //   if ($scope.info.features.reminders && $scope.role.showReminder) {
    //     $scope.expiredColor = "#f26a5d";
    //     $scope.importanceColors = [
    //       {
    //         type: "LOW",
    //         color: "#27b96b",
    //       },
    //       {
    //         type: "NORMAL",
    //         color: "#27c2eb",
    //       },
    //       {
    //         type: "HIGH",
    //         color: "#f29a25",
    //       },
    //     ];
    //     CompanyTaskService.query({
    //       companyId: $stateParams.companyId,
    //       status: "INCOMPLETE",
    //       limit: 4,
    //     }).$promise.then(
    //       function(resp) {
    //         $scope.latestTasks = resp;
    //         if (!boxReminder[0]) {
    //           if ($scope.latestTasks.length > 0) {
    //             $scope.role.template.data.push({
    //               isChart: false,
    //               centralInformation: false,
    //               columnType: "REMINDER",
    //               isFullBox: false,
    //               chartData: {
    //                 gsX: 0,
    //                 gsY: yMax + heigthMax,
    //                 gsWidth: 4,
    //                 gsHeigth: 4,
    //               },
    //             });
    //             setTimeout(function() {
    //               var grid = jQuery(".grid-stack").data("gridstack");
    //               grid.addWidget(
    //                 jQuery(".grid-stack-item:last-child"),
    //                 0,
    //                 yMax + heigthMax,
    //                 4,
    //                 4,
    //                 true
    //               );
    //             }, 1000);
    //           }
    //         } else {
    //           if ($scope.latestTasks.length === 0) {
    //             $scope.role.template.data.splice(
    //               $scope.role.template.data.indexOf(boxReminder[0]),
    //               1
    //             );
    //           }
    //         }
    //       },
    //       function() {
    //         if (boxReminder[0]) {
    //           $scope.role.template.data.splice(
    //             $scope.role.template.data.indexOf(boxReminder[0]),
    //             1
    //           );
    //         }
    //       }
    //     );
    //   } else {
    //     if (boxReminder[0]) {
    //       $scope.role.template.data.splice(
    //         $scope.role.template.data.indexOf(boxReminder[0]),
    //         1
    //       );
    //     }
    //   }
    // }
  // }

  angular.forEach($scope.role.menus, function(v, i) {
    if (angular.isUndefined(v.id)) {
      v.id = i + 1;
    }
  });

  $scope.members = members;
  $scope.apiBase = config.apiBase;

  var isCurrentUserRole = $scope.members.some(function(v) {
    return v.id === $scope.currentUser.id;
  });

  $scope.showModalUserLink = function(link, index) {
    $modal({
      scope: $scope,
      controller: "CompanyUserLinksCtrl",
      templateUrl: "partials/company/publications/lists/user-link.html",
      show: true,
      prefixEvent: "userLinkModal",
      resolve: {
        link: function() {
          return link || false;
        },
        index: function() {
          return angular.isUndefined(index) ? -1 : index;
        },
      },
    });
  };

  $scope.showModalLink = function(isMenu) {
    $modal({
      scope: $scope,
      controller: [
        "$scope",
        function($scope) {
          $scope.newLink = {
            text: "",
            link: "",
          };
          if (isMenu) {
            $scope.newLink.id = $scope.role.menus.length + 1;
          }
          $scope.isMenu = isMenu;

          $scope.saveLink = function() {
            $scope.newLink.show = true;
            if ($scope.newLink.link.indexOf(config.appBase) !== -1) {
              if (!angular.isArray($scope.newLink.groups)) {
                $scope.newLink.group = [];
              }
              var fullUserUrlRegex = /companies\/(.*)/i;
              if (
                !fullUserUrlRegex.test($scope.newLink.link) ||
                !checkPermissionGroup($scope.newLink.groups)
              ) {
                $scope.newLink.show = false;
              }
            }
            if (isMenu) {
              $scope.role.menus.push($scope.newLink);
            } else {
              $scope.role.links.push($scope.newLink);
            }
            $scope.save();
            $scope.$hide();
          };
        },
      ],
      templateUrl: "partials/company/user-roles/modal-create-link.html",
      show: true,
    });
  };

  $scope.save = function() {
    $scope.saving = true;
    if ($scope.role.template) {
      $scope.role.template.id = $scope.role.template.id.toString();
    }
    var rolesNotId = [];
    if ($scope.role.template && $scope.role.template.data) {
      rolesNotId = $scope.role.template.data.filter(function(value) {
        return !value.id;
      });
    }
    var roleDeferred = $q.defer();
    if (rolesNotId.length === 0) {
      roleDeferred.resolve();
    } else {
      var number = 0;
      angular.forEach(rolesNotId, function(value) {
        var textBox = {
          text: value.text,
          id: value.id,
          isFullBox: value.isFullBox,
          boxID: value.reference ? value.reference.boxID : null,
          userRoleID: value.reference ? value.reference.userRoleID : null,
          centralInformation: value.centralInformation,
          imgTarget : value.imgTarget,
          headerText: value.headerText,
          removeBox: value.removeBox,
          removeBackground: value.removeBackground,
          isChart: value.isChart,
          chartData: JSON.stringify(value.chartData),
          columnType: value.columnType,
          columnData: JSON.stringify(value.columnData),
        };
        CompanyUserRoleService.saveTextbox(
          {
            companyId: $stateParams.companyId,
            roleId: $stateParams.roleId,
          },
          textBox,
          function(res) {
            $scope.role.template.data[
              $scope.role.template.data.indexOf(value)
            ].id = res.id;
            if (number === rolesNotId.length - 1) {
              roleDeferred.resolve();
            }
            number++;
          },
          function(err) {
            if (err.status === 400) {
              growl.addErrorMessage(err.data.error.message);
            } else {
              growl.addErrorMessage(
                $translate.instant("user-role.save-failure")
              );
            }
            if (number === rolesNotId.length - 1) {
              roleDeferred.resolve();
            }
            number++;
          }
        );
      });
    }
    roleDeferred.promise.then(function() {
      $scope.role.$update(
        {
          companyId: $stateParams.companyId,
          roleId: $stateParams.roleId,
        },
        function() {
          if (isCurrentUserRole) {
            $scope.$emit("roleChanged", $scope.role);
          }
          lastTemplateData = $scope.role;
          growl.addSuccessMessage($translate.instant("user-role.save-success"));
          $scope.nestedMenu = getNestedChildren($scope.role.menus, null);
          $scope.saving = false;
        },
        function() {
          $scope.saving = false;
          growl.addErrorMessage($translate.instant("user-role.save-failure"));
        }
      );
    });
  };

  // $scope.saveTextbox = function(id, data) {
  //   var dataTemplate =
  //     $scope.role.template.data[$scope.role.template.data.indexOf(data)];
  //   var textBox = {
  //     text: dataTemplate.text,
  //     id: id,
  //     isFullBox: dataTemplate.isFullBox,
  //     boxID: dataTemplate.reference ? dataTemplate.reference.boxID : null,
  //     userRoleID: dataTemplate.reference
  //       ? dataTemplate.reference.userRoleID
  //       : null,
  //     centralInformation: dataTemplate.centralInformation,
  //     imgTarget : dataTemplate.imgTarget,
  //     headerText: dataTemplate.headerText,
  //     removeBox: dataTemplate.removeBox,
  //     removeBackground: dataTemplate.removeBackground,
  //     isChart: dataTemplate.isChart,
  //     chartData: JSON.stringify(dataTemplate.chartData),
  //     columnType: dataTemplate.columnType,
  //     columnData: JSON.stringify(dataTemplate.columnData),
  //   };
  //   CompanyUserRoleService.saveTextbox(
  //     {
  //       companyId: $stateParams.companyId,
  //       roleId: $stateParams.roleId,
  //     },
  //     textBox,
  //     function() {
  //       if (isCurrentUserRole) {
  //         $scope.$emit("roleChanged", $scope.role);
  //       }
  //       modalEdit.$promise.then(modalEdit.hide);
  //       $state.reload();
  //     },
  //     function(err) {
  //       if (err.status === 400) {
  //         growl.addErrorMessage(err.data.error.message);
  //       } else {
  //         growl.addErrorMessage($translate.instant("user-role.save-failure"));
  //       }
  //     }
  //   );
  // };
  // $scope.useDashboard = function(templateId) {
  //   if (!$scope.role.template) {
  //     $scope.role.template = { id: templateId };
  //   } else {
  //     $scope.role.template.id = templateId;
  //   }
  //   setTimeout(function() {
  //     var options = {};
  //     jQuery(".grid-stack").gridstack(options);
  //   }, 1000);
  // };

  // $scope.checkColors = function(xAxesDisplay) {
  //   if (
  //     $scope.role.template &&
  //     $scope.role.template.data &&
  //     $scope.role.template.id
  //   ) {
  //     angular.forEach($scope.role.template.data, function(v, k) {
  //       if (v.isChart && v.chartData) {
  //         if (v.chartData.type === "line-bar") {
  //           $scope.role.template.data[k].options = {
  //             legend: {
  //               display: true,
  //               position: "bottom",
  //             },
  //             scales: {
  //               xAxes: [
  //                 {
  //                   ticks: {
  //                     display: true,
  //                   },
  //                 },
  //               ],
  //               yAxes: [],
  //             },
  //           };
  //           if (xAxesDisplay <= 483) {
  //             $scope.role.template.data[
  //               k
  //             ].options.scales.xAxes[0].ticks.display = false;
  //           } else {
  //             if (xAxesDisplay < 999) {
  //               if (xAxesDisplay > 807) {
  //                 if (
  //                   $scope.role.template.id === "5" ||
  //                   $scope.role.template.id === "6"
  //                 ) {
  //                   if (k === 0) {
  //                     $scope.role.template.data[
  //                       k
  //                     ].options.scales.xAxes[0].ticks.display = false;
  //                   } else {
  //                     if ($scope.role.template.id === "6") {
  //                       $scope.role.template.data[
  //                         k
  //                       ].options.scales.xAxes[0].ticks.display = false;
  //                     } else {
  //                       $scope.role.template.data[
  //                         k
  //                       ].options.scales.xAxes[0].ticks.display = true;
  //                     }
  //                   }
  //                 } else {
  //                   $scope.role.template.data[
  //                     k
  //                   ].options.scales.xAxes[0].ticks.display = true;
  //                 }
  //               } else {
  //                 $scope.role.template.data[
  //                   k
  //                 ].options.scales.xAxes[0].ticks.display = true;
  //               }
  //             } else {
  //               if (
  //                 (($scope.role.template.id === "5" ||
  //                   $scope.role.template.id === "6") &&
  //                   k === 0) ||
  //                 !v.isFullBox
  //               ) {
  //                 $scope.role.template.data[
  //                   k
  //                 ].options.scales.xAxes[0].ticks.display = false;
  //               }
  //             }
  //           }
  //         } else {
  //           $scope.role.template.data[k].options = {
  //             legend: {
  //               display: true,
  //               position: "bottom",
  //             },
  //           };
  //           if (v.chartData.type === "bar" || v.chartData.type === "line") {
  //             $scope.role.template.data[k].options = {
  //               legend: {
  //                 display: true,
  //                 position: "bottom",
  //               },
  //               scales: {
  //                 xAxes: [
  //                   {
  //                     ticks: {
  //                       display: true,
  //                     },
  //                   },
  //                 ],
  //               },
  //             };
  //             if (xAxesDisplay <= 483) {
  //               $scope.role.template.data[
  //                 k
  //               ].options.scales.xAxes[0].ticks.display = false;
  //             } else {
  //               if (xAxesDisplay < 999) {
  //                 if (xAxesDisplay > 807) {
  //                   if (
  //                     $scope.role.template.id === "5" ||
  //                     $scope.role.template.id === "6"
  //                   ) {
  //                     if (k === 0) {
  //                       $scope.role.template.data[
  //                         k
  //                       ].options.scales.xAxes[0].ticks.display = false;
  //                     } else {
  //                       if ($scope.role.template.id === "6") {
  //                         $scope.role.template.data[
  //                           k
  //                         ].options.scales.xAxes[0].ticks.display = false;
  //                       } else {
  //                         $scope.role.template.data[
  //                           k
  //                         ].options.scales.xAxes[0].ticks.display = true;
  //                       }
  //                     }
  //                   } else {
  //                     $scope.role.template.data[
  //                       k
  //                     ].options.scales.xAxes[0].ticks.display = true;
  //                   }
  //                 } else {
  //                   $scope.role.template.data[
  //                     k
  //                   ].options.scales.xAxes[0].ticks.display = true;
  //                 }
  //               } else {
  //                 if (
  //                   (($scope.role.template.id === "5" ||
  //                     $scope.role.template.id === "6") &&
  //                     k === 0) ||
  //                   !v.isFullBox
  //                 ) {
  //                   $scope.role.template.data[
  //                     k
  //                   ].options.scales.xAxes[0].ticks.display = false;
  //                 }
  //               }
  //             }
  //           }
  //         }
  //         if (v.chartData.type !== "doughnut" && v.chartData.type !== "pie") {
  //           $scope.role.template.data[k].datasetOverride = [];
  //           angular.forEach(v.chartData.colors, function(value, key) {
  //             if (v.chartData.type === "line-bar") {
  //               $scope.role.template.data[k].datasetOverride.push({
  //                 yAxisID: "y-axis-" + (key + 1),
  //                 borderWidth: key === 0 ? 2 : 1,
  //                 backgroundColor: key === 0 ? "transparent" : value,
  //                 pointBackgroundColor: key === 0 ? "transparent" : value,
  //                 borderColor: value,
  //                 pointBorderColor: value,
  //                 type: key === 0 ? "line" : "bar",
  //               });
  //               $scope.role.template.data[k].options.scales.yAxes.push({
  //                 id: "y-axis-" + (key + 1),
  //                 display: true,
  //                 position: key === 0 ? "left" : "right",
  //               });
  //             } else {
  //               $scope.role.template.data[k].datasetOverride.push({
  //                 borderWidth: v.chartData.type === "line" ? 2 : 1,
  //                 backgroundColor:
  //                   v.chartData.type === "line" ? "transparent" : value,
  //                 pointBackgroundColor:
  //                   v.chartData.type === "line" ? "transparent" : value,
  //                 borderColor: value,
  //                 pointBorderColor: value,
  //               });
  //             }
  //           });
  //         }
  //       }
  //     });
  //   }
  // };

  // var widthWindow = angular.element($window).width();
  // $scope.checkColors(widthWindow);
  // angular.element($window).on("resize", function() {
  //   widthWindow = angular.element($window).width();
  //   $scope.$apply(function() {
  //     $scope.checkColors(widthWindow);
  //   });
  // });

  // $scope.loadBlogs = function(filter) {
  //   CompanyPublicationService.query({
  //     companyId: $stateParams.companyId,
  //     limit: 20,
  //     orderby: "created",
  //     qType: "GENERAL",
  //     type: "BLOG",
  //     q: filter,
  //   }).$promise.then(function(blogs) {
  //     $scope.blogs = blogs;
  //   });
  // };

  // $scope.addBulkColumn = function(columnType) {
  //   $scope.role.template.data = angular.isArray($scope.role.template.data)
  //     ? $scope.role.template.data
  //     : [];
  //   var gsYMax = 0;
  //   var gsHeigthMax = 4;
  //   angular.forEach($scope.role.template.data, function(d) {
  //     if (parseInt(d.chartData.gsY) > gsYMax) {
  //       gsYMax = parseInt(d.chartData.gsY);
  //       gsHeigthMax = parseInt(d.chartData.gsHeigth);
  //     }
  //   });
  //   var newTextBox = {};
  //   if (columnType === "CHART") {
  //     newTextBox = {
  //       isChart: true,
  //       columnType: "CHART",
  //       chartData: {
  //         title: "",
  //         type: "bar",
  //         gsX: 0,
  //         gsY: gsYMax + gsHeigthMax,
  //         gsWidth: 4,
  //         gsHeigth: 4,
  //       },
  //     };
  //   } else {
  //     if (columnType === "BLOG") {
  //       newTextBox = {
  //         isChart: false,
  //         columnType: "BLOG",
  //         columnData: {
  //           blogId: null,
  //           only: "NONE",
  //         },
  //         chartData: {
  //           gsX: 0,
  //           gsY: gsYMax + gsHeigthMax,
  //           gsWidth: 4,
  //           gsHeigth: 4,
  //         },
  //       };
  //     } else {
  //       if (columnType === "INFO") {
  //         newTextBox = {
  //           isChart: false,
  //           columnType: "INFO",
  //           columnData: {},
  //           chartData: {
  //             fontColor: 4293813849,
  //             backgroundColor: 4278190080,
  //             gsX: 0,
  //             gsY: gsYMax + gsHeigthMax,
  //             gsWidth: 4,
  //             gsHeigth: 4,
  //           },
  //         };
  //       } else {
  //         if ($scope.userRoles.length > 0) {
  //           $scope.userRoles[0].template.data = angular.isArray(
  //             $scope.userRoles[0].template.data
  //           )
  //             ? $scope.userRoles[0].template.data
  //             : [];
  //           var referenceCentralInformation = $scope.userRoles[0].template.data.filter(
  //             function(item) {
  //               return item.centralInformation === false;
  //             }
  //           );
  //           newTextBox = {
  //             text: "",
  //             img: "",
  //             columnType: "DEFAULT",
  //             isChart: false,
  //             centralInformation: false,
  //             userRoleCurrent: $scope.userRoles[0],
  //             referenceCentralInformation: referenceCentralInformation,
  //             currentIndex:
  //               $scope.userRoles[0].template.data.indexOf(
  //                 referenceCentralInformation[0]
  //               ) + 1,
  //             reference: {
  //               boxID:
  //                 $scope.userRoles[0].template.data[0] !== undefined
  //                   ? $scope.userRoles[0].template.data[0].id
  //                   : null,
  //               userRoleID:
  //                 $scope.userRoles[0] !== undefined
  //                   ? $scope.userRoles[0].id
  //                   : null,
  //             },
  //             chartData: {
  //               gsX: 0,
  //               gsY: gsYMax + gsHeigthMax,
  //               gsWidth: 4,
  //               gsHeigth: 4,
  //             },
  //           };
  //         } else {
  //           newTextBox = {
  //             isChart: false,
  //             columnType: "DEFAULT",
  //             text: "",
  //             img: "",
  //             chartData: {
  //               gsX: 0,
  //               gsY: gsYMax + gsHeigthMax,
  //               gsWidth: 4,
  //               gsHeigth: 4,
  //             },
  //           };
  //         }
  //       }
  //     }
  //   }
  //   $scope.role.template.data.push(newTextBox);
  //   setTimeout(function() {
  //     var grid = jQuery(".grid-stack").data("gridstack");
  //     grid.addWidget(
  //       jQuery(".grid-stack-item:last-child"),
  //       newTextBox.chartData.gsX,
  //       newTextBox.chartData.gsY,
  //       newTextBox.chartData.gsWidth,
  //       newTextBox.chartData.gsHeigth,
  //       true
  //     );
  //   }, 1000);
  // };

  // var modalEdit;
  // $scope.showModalEditTextBox = function(data) {
  //   modalEdit = $modal({
  //     scope: $scope,
  //     controller: "CompanyEditTextBoxCtrl",
  //     resolve: {
  //       data: function() {
  //         return data || [];
  //       },
  //     },
  //     templateUrl: "partials/company/user-roles/modal-edit-textbox.html",
  //     show: false,
  //   });
  //   modalEdit.$promise.then(modalEdit.show);
  // };

  // $scope.onFileSelect = function(
  //   files,
  //   text,
  //   id,
  //   boxID,
  //   userRoleID,
  //   centralInformation
  // ) {
  //   if (!Array.isArray(files)) {
  //     return;
  //   }

  //   return uploadTracker(
  //     files.map(function(f) {
  //       return {
  //         url:
  //           config.apiBase +
  //           "/companies/" +
  //           $stateParams.companyId +
  //           "/user-roles/" +
  //           $stateParams.roleId,
  //         file: f,
  //         fields: {
  //           text: text,
  //           id: id,
  //           boxID: boxID,
  //           userRoleID: userRoleID,
  //           centralInformation: centralInformation,
  //           columnType: "DEFAULT",
  //         },
  //       };
  //     })
  //   ).then(function(files) {
  //     var indexData = $scope.role.template.data.filter(function(item) {
  //       return item.id === id;
  //     })[0];
  //     if (
  //       $scope.role.template.data[$scope.role.template.data.indexOf(indexData)]
  //         .img === ""
  //     ) {
  //       $scope.role.template.data[
  //         $scope.role.template.data.indexOf(indexData)
  //       ].img = files[0];
  //     }
  //     if (!id) {
  //       $scope.role.template.data[
  //         $scope.role.template.data.indexOf(indexData)
  //       ].id = files[0];
  //     }
  //     $scope.$broadcast("imageChanged");
  //     if (isCurrentUserRole) {
  //       $scope.$emit("roleChanged", $scope.role);
  //     }
  //   });
  // };

  $scope.addMember = function(member) {
    CompanyUserRoleService.addMember(
      { companyId: $stateParams.companyId, roleId: $stateParams.roleId },
      { user: member },
      function() {
        $scope.members.push(member);
        if (isCurrentUserRole) {
          $scope.$emit("roleChanged", $scope.role);
        }
        growl.addSuccessMessage(
          $translate.instant("user-role.add-member-success")
        );
        $scope.addedUser = "";
        $scope.nonMembers.splice($scope.nonMembers.indexOf(member), 1);
      },
      function() {
        growl.addErrorMessage(
          $translate.instant("user-role.add-member-failure")
        );
      }
    );
  };

  $scope.deleteWatcher = function(member) {
    CompanyUserRoleService.removeMember(
      {
        companyId: $stateParams.companyId,
        roleId: $stateParams.roleId,
        userId: member.id,
      },
      function() {
        if (isCurrentUserRole) {
          $scope.$emit("roleChanged", $scope.role);
        }
        growl.addSuccessMessage(
          $translate.instant("customer-portals.remove-member-success")
        );
        $scope.members.splice($scope.members.indexOf(member), 1);
      },
      function() {
        growl.addErrorMessage(
          $translate.instant("customer-portals.remove-member-failure")
        );
      }
    );
  };

  $scope.nonMembers = [];
  $scope.queryUsers = function(text) {
    CompanyUserService.query({
      companyId: $stateParams.companyId,
      q: text,
      limit: 10,
    }).$promise.then(function(u) {
      $scope.nonMembers = u.filter(function(u) {
        return !$scope.members.some(function(member) {
          return member.id === u.id;
        });
      });
    });
  };

  $scope.removeImage = function(i) {
    var oldImg = role.template.data[i].img;
    role.template.data[i].img = "";
    $scope.role.$update(
      {
        companyId: $stateParams.companyId,
        roleId: $stateParams.roleId,
      },
      function() {
        if (isCurrentUserRole) {
          $scope.$emit("roleChanged", $scope.role);
        }
        growl.addSuccessMessage($translate.instant("user-role.save-success"));
      },
      function() {
        role.template.data[i].img = oldImg;
        growl.addErrorMessage($translate.instant("user-role.save-failure"));
      }
    );
  };
}

CompanyUserRoleEditCtrl.resolve = {
  role: [
    "CompanyUserRoleService",
    "$stateParams",
    function(userRoleService, $stateParams) {
      return userRoleService.get({
        companyId: $stateParams.companyId,
        roleId: $stateParams.roleId,
      }).$promise;
    },
  ],
  userRoles: [
    "CompanyUserRoleService",
    "$stateParams",
    function(userRoleService, $stateParams) {
      return userRoleService.query({
        companyId: $stateParams.companyId,
        limit: 100,
      }).$promise;
    },
  ],
  members: [
    "CompanyUserRoleService",
    "$stateParams",
    function(userRoleService, $stateParams) {
      return userRoleService.queryUsers({
        companyId: $stateParams.companyId,
        roleId: $stateParams.roleId,
        all: true,
      }).$promise;
    },
  ],
};

module.exports = CompanyUserRoleEditCtrl;

angular
  .module("dokiv")
  .controller("CompanyUserRoleEditCtrl", CompanyUserRoleEditCtrl)
  .directive("menuEdit", [
    "CompanyPublicationService",
    "config",
    "$timeout",
    EditMenuDirective,
  ])

function EditMenuDirective(CompanyPublicationService, config, $timeout) {
  return {
    restrict: "A",
    replace: true,
    scope: {
      currentMenu: "=",
      nestedMenu: "=",
      role: "=",
      remove: "&onRemove",
      companyId: "=",
    },

    link: function($scope, elem) {
      if (!$scope.currentMenu.hasOwnProperty("isPortalLink")) {
        $scope.currentMenu.isPortalLink = false;
      }
      $scope.toggle = false;
      $scope.toggleDropdownMenu = false;
      $scope.$watch(
        "currentMenu",
        function(newVal, oldVal) {
          $scope.$emit("menuChange", JSON.parse(JSON.stringify(newVal)));
          if (!newVal.text) {
            $scope.toggle = true;
          }
        },
        true
      );

      $scope.changeParent = function(parentId) {
        if ($scope.currentMenu.id !== parentId) {
          $scope.currentMenu.parentId = parentId;
          $scope.toggleDropdownMenu = false;
        }
      };

      $scope.remove = function() {
        $scope.$emit("removeMenuItem", $scope.currentMenu);
      };

      $scope.isDokivLink = function(link) {
        var regex = /http[s]?:\/\/?(?:portal|app).+?\.?dokiv\.com+\/([^\/\s]+\/).*/;
        return regex.test(link);
      };

      $scope.toggleLink = function(link) {
        if (isDokivLink) {
          var portalRegex = /http[s]?:\/\/?portal.+?\.?dokiv\.com+\/([^\/\s]+)\/.*/;
          var appRegex = /http[s]?:\/\/?app.+?\.?dokiv\.com+\/([^\/\s]+)\/.*/;
        }

        return link;
      };

      $scope.setLink = function(publication) {
        if (
          $scope.currentMenu.isPortalLink &&
          (publication.type === "FORM" ||
            publication.type === "ALBUM" ||
            publication.type === "DEFAULT" ||
            publication.type === "NOTE")
        ) {
          $scope.currentMenu.link =
            config.portalUrl +
            "/app/companies/" +
            $scope.companyId +
            "/publications/" +
            publication.id +
            "/" +
            publication.type.toLowerCase();
        } else {
          if (
            publication.type !== "FORM" &&
            publication.type !== "PUBLICATION_SPREAD_SHEET" &&
            publication.type !== "COMPANY_ORDER" &&
            publication.type !== "ORDER_SUBCRIPTION"
          ) {
            $scope.currentMenu.link =
              config.appBase +
              "/companies/" +
              $scope.companyId +
              "/publications/" +
              publication.id;
          } else {
            if (publication.type === "PUBLICATION_SPREAD_SHEET") {
              $scope.currentMenu.link =
                config.appBase +
                "/spreadsheet/" +
                $scope.companyId +
                "/publications/" +
                publication.id;
            }
            if (publication.type === "FORM") {
              if (
                publication.features.formActived === "false" ||
                !!publication.features.formActived === false
              ) {
                $scope.currentMenu.link =
                  config.appBase +
                  "/forms/companies/" +
                  $scope.companyId +
                  "/publications/" +
                  publication.id +
                  "/detail";
              } else {
                $scope.currentMenu.link =
                  config.appBase +
                  "/forms/companies/" +
                  $scope.companyId +
                  "/publications/" +
                  publication.id +
                  "/form-submit";
              }
            }
            if (publication.type === "COMPANY_ORDER") {
              $scope.currentMenu.link =
                config.appBase +
                "/order/" +
                $scope.companyId +
                "/detail/" +
                publication.id;
            }
            if (publication.type === "ORDER_SUBCRIPTION") {
              $scope.currentMenu.link =
                config.appBase +
                "/order/" +
                $scope.companyId +
                "/subcription-detail/" +
                publication.id;
            }
          }
        }

        $scope.toggleSearch = false;
        $scope.search = "";
        $scope.objects = [];
      };

      var searchTimeout;
      $scope.query = function(search) {
        if (searchTimeout) {
          $timeout.cancel(searchTimeout);
          searchTimeout = null;
        }
        searchTimeout = $timeout(function() {
          CompanyPublicationService.query({
            companyId: $scope.companyId,
            q: search,
            limit: 50,
          }).$promise.then(function(publications) {
            $scope.objects = $scope.currentMenu.isPortalLink
              ? publications.filter(function(p) {
                  return (
                    p.type === "DEFAULT" ||
                    p.type === "FORM" ||
                    p.type === "NOTE" ||
                    p.type === "ALBUM"
                  );
                })
              : publications;
          });
        }, 200);
      };
    },

    templateUrl: "partials/company/user-roles/menu-edit.html",
  };
}

EditMenuDirective.$inject = ["CompanyPublicationService", "config", "$timeout"];



//////////////////
// WEBPACK FOOTER
// ./scripts/company/user-roles/CompanyUserRoleEditCtrl.js
// module id = 426
// module chunks = 0